import { tokens } from '@arvoreeducacao/bonsai-ds'
import type { FunctionComponent } from 'react'
import React, { Fragment, useState, useEffect } from 'react'

import ContentInfo from './content-info'
import ExtraControls from './extra-controls'
import PlayerControls from './player-controls'
import { Container } from './PlayerBar.styles'
import PlayerBarMinified from './player-bar-minified'
import { usePlayerContext } from 'context/player'

const PlayerBar: FunctionComponent = () => {
  const [isMdScreen, setIsMdScreen] = useState(
    window.innerWidth <= tokens.sizes.mdScreen
  )
  const {
    state: { isMinimized }
  } = usePlayerContext()

  const handleResize = () => {
    setIsMdScreen(window.innerWidth <= tokens.sizes.mdScreen)
  }
  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Fragment>
      {isMdScreen && isMinimized ? (
        <PlayerBarMinified />
      ) : (
        <Container data-testid="desktop-player">
          <ContentInfo />

          <PlayerControls />

          <ExtraControls />
        </Container>
      )}
    </Fragment>
  )
}

export default PlayerBar
